var _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgProjectIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20.16,
    height: 20.16,
    rx: 2.52,
    fill: "#45B872"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9125 8.91111C14.5109 8.91111 15 9.4016 15 10.0111C14.9308 10.3242 14.9308 10.3242 14.9011 10.3524C14.8753 10.3939 14.8753 10.3939 14.8497 10.4317C14.8176 10.4789 14.7734 10.5407 14.7164 10.6184C14.6128 10.7598 14.4649 10.9565 14.2756 11.2051C13.9442 11.6404 13.4925 12.2262 12.9497 12.9255L12.9206 12.9629C12.4936 13.5129 12.0362 14.0998 11.5788 14.6851C11.4188 14.89 11.2701 15.08 11.1367 15.2504C10.9994 15.4257 10.9994 15.4256 10.9689 15.4647L10.9243 15.5155C10.5904 15.8555 10.2712 16 10.0125 16C9.41409 16 8.925 15.5095 8.925 14.9V12.0732H7.16258L7.06201 12.0646C6.49116 11.9658 6 11.6064 6 10.9889C6 10.6677 6.11288 10.5181 8.0249 8.07455C8.05291 8.03876 8.05291 8.03876 8.08092 8.00299C8.50832 7.45717 8.96607 6.87689 9.42381 6.29951C9.58399 6.09744 9.73275 5.91017 9.86626 5.74235C10.0036 5.56978 10.0036 5.56978 10.0611 5.50004L10.1785 5.37185C10.3835 5.13946 10.6719 5 10.9875 5C11.5859 5 12.075 5.49049 12.075 6.1V8.91111H13.9125Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectIcon);
export default __webpack_public_path__ + "static/media/project-icon.f44b011f.svg";
export { ForwardRef as ReactComponent };